module.exports = __webpack_public_path__ + "img/download-meduim-icon.b82cf0fd.svg";